<template>
  <div v-if="purchaseData" class="tw-text-center">
    <h2 class="tw-text-left">Purchase Confirmation</h2>
    <div class="tw-mb-4 tw-text-left">
      <SchoolActivationPeriod
        :spelling-period="spellingPeriod"
        :maths-period="mathsPeriod"
      />
    </div>
    <div class="tw-mb-8">
      <PurchaseResume
        :mode="mode"
        :school-reference="schoolReference"
        :purchase-data="purchaseData"
      />
      <div
        v-if="activateTrial && purchaseData.availableTrial"
        class="tw-font-bold"
      >
        Activate {{ purchaseData.availableTrial.type }}
        {{ purchaseData.availableTrial.length }} days trial
      </div>
    </div>
    <div>
      <button @click="$emit('modify')" class="sf-btn-primary">Modify</button>
      <button @click.prevent="requestInvoice" class="sf-btn-primary">
        Request Invoice
      </button>
      <button @click.prevent="$emit('paywithcard')" class="sf-btn-primary">
        Pay With Credit Card
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import apiCall from "@/func/net/apiCall";
import { SfPurchaseType, SfStorePurchaseData } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";
import PurchaseResume from "./PurchaseResume.vue";
import SchoolActivationPeriod from "@/views/site/SchoolActivationPeriod.vue";

export default defineComponent({
  components: { PurchaseResume, SchoolActivationPeriod },
  emits: ["modify", "paywithcard"],
  props: {
    mode: { type: String as PropType<SfPurchaseType>, required: true },
    schoolReference: { type: String, required: true },
    activateTrial: { type: Boolean, defdault: false },
    purchaseData: { type: Object as PropType<SfStorePurchaseData | null> },
  },
  data() {
    return {};
  },
  computed: {
    spellingClassCount() {
      if (!this.purchaseData) {
        return 0;
      }
      let res = 0;
      for (let p of this.purchaseData.products) {
        if (p.name == "classSpelling") {
          res += p.count;
        }
      }
      return res;
    },
    mathsClassCount() {
      if (!this.purchaseData) {
        return 0;
      }
      let res = 0;
      for (let p of this.purchaseData.products) {
        if (p.name == "classMaths") {
          res += p.count;
        }
      }
      return res;
    },
    spellingPeriod() {
      const p = this.purchaseData?.products.find((p) => p.kind == "spelling");
      return p ? p.period : null;
    },
    mathsPeriod() {
      const p = this.purchaseData?.products.find((p) => p.kind == "maths");
      return p ? p.period : null;
    },
  },
  methods: {
    async requestInvoice() {
      const postData = {
        paymentMethod: 1,
        schoolId: this.$currentUser.value?.school?.id,
        spellingClassCount: this.spellingClassCount,
        mathsClassCount: this.mathsClassCount,
        schoolReference: this.schoolReference,
        kind: this.mode,
        activateTrial: this.activateTrial,
      };
      const resData = await apiCall(
        "purchase/school",
        null,
        { method: "POST" },
        postData,
      );
      if (resData.success) {
        window.location.href = "/dashboard";
      }
    },
  },
});
</script>
